export default __webpack_public_path__ + "static/media/gettingStartedStep2.9f3f8146.png";